import { isUnsafeMethod, readXsrfToken } from '@/lib/csrf';

/**
 * A raw `fetch` for the embedded pedigree editor's granular data service (PTV2-1157). Mirrors the
 * app's http client: attaches the BFF session cookie (`credentials: 'include'`) and echoes the
 * CSRF token on unsafe methods. Injected into the editor via `endpoints.getApiFetch` so the editor
 * reuses PTV2's auth instead of its own same-origin fetch. The editor targets
 * `/core/api/v2/pedigree/…` (structure) and `/core/api/v1/persons/…` (hydration).
 */
export function createPtv2Fetch(): typeof fetch {
  return (input, init) => {
    const method = (init?.method ?? 'GET').toUpperCase();
    const headers = new Headers(init?.headers ?? {});
    if (isUnsafeMethod(method)) {
      const csrf = readXsrfToken();
      if (csrf !== null) {
        headers.set('X-XSRF-TOKEN', csrf);
      }
    }
    return fetch(input, { ...init, credentials: 'include', headers });
  };
}
